import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CameraswitchIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cameraswitch"}/>
}
